import { authHeader } from '../helpers';
import { generalConstants } from '../constants';

export const generalService = {
  getSetting,
  getContent,
  postContent,
  putContent,
  deleteContent,
  getNotification,
  postUpload,
  postFile,
  getFile
};

//============================= SETTING ==================================
// getSetting   ->  get data from API

function getSetting() {
  const requestOptions = {
    method: 'GET',
    headers: { 'x-api-key': generalConstants.API_KEY }
  };

  return fetch(generalConstants.BASE_URL + 'api/setting/settings/', requestOptions)
    .then(handleResponse)
    .then(data => {
      // login successful if there's a jwt token in the response
      if (data) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('setting', JSON.stringify(data.data));
      }
      return data;
    });
}

//============================= CONTENT ==================================
// getContent   ->  get data from API
// postContent  ->  post new data to API
// putContent   ->  edit data to API

function getContent(id, page_id) {
  const requestOptions = {
    method: 'GET',
    headers: { 'x-api-key': generalConstants.API_KEY }
  };

  return fetch(
    generalConstants.BASE_URL + 'api/content/contents/' + id + '/' + page_id,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function postContent(data, id, pid) {
  const requestOptions = {
    method: 'POST',
    headers: { 'x-api-key': generalConstants.API_KEY, 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  };

  return fetch(generalConstants.BASE_URL + 'api/content/contents/' + id + '/' + pid, requestOptions).then(
    handleResponse
  );
}

function putContent(data, pid) {
  const requestOptions = {
    method: 'PUT',
    headers: { 'x-api-key': generalConstants.API_KEY, 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  };

  return fetch(generalConstants.BASE_URL + 'api/content/contents/' + pid, requestOptions).then(
    handleResponse
  );
}

function deleteContent(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: { 'x-api-key': generalConstants.API_KEY, 'Content-Type': 'application/json' }
  };

  return fetch(generalConstants.BASE_URL + 'api/content/contents/' + id, requestOptions).then(
    handleResponse
  );
}

//============================= NOTIFICATION ==================================
// getNotification   ->  get data from API

function getNotification(menu_id) {
  const requestOptions = {
    method: 'GET',
    headers: { 'x-api-key': generalConstants.API_KEY }
  };

  return fetch(generalConstants.BASE_URL + 'api/notification/notifications/', requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

//============================= UPLOADER ==================================

function postUpload(file) {
  const requestOptions = {
    method: 'POST',
    headers: { 'x-api-key': generalConstants.API_KEY },
    body: file
  };

  return fetch(generalConstants.BASE_URL + 'api/upload/uploads/', requestOptions).then(
    handleResponse
  );
}

function handleResponse(response) {
  if (!response.ok) {
    return Promise.reject(response.statusText);
  }
  return response.json();
}

function postFile(data) {
  const requestOptions = {
    method: 'POST',
    headers: { 'x-api-key': generalConstants.API_KEY, 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  };

  return fetch(generalConstants.BASE_URL + 'api/file/files/', requestOptions).then(handleResponse);
}

function getFile() {
  const requestOptions = {
    method: 'GET',
    headers: { 'x-api-key': generalConstants.API_KEY }
  };

  return fetch(generalConstants.BASE_URL + 'api/file/files/', requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}



// WEBPACK FOOTER //
// ./src/services/general.service.js